<template> </template>
<script>
export default {
  created: function() {
    this.$router.push("/");
  },
};
</script>
